import { application } from "./application"

import MenuController from "./menu_controller"
import ToggleController from "./toggle_controller"
import VoiceRecorderController from "./voice_recorder_controller"
import SegmentController from "./segment_controller"
import RecorderController from "./recorder_controller"
import CollapsibleController from "./collapsible_controller"
import ScrollRevealController from "./scroll_reveal_controller"

application.register("menu", MenuController)
application.register("toggle", ToggleController)
application.register("voice-recorder", VoiceRecorderController)
application.register("segment", SegmentController)
application.register("recorder", RecorderController)
application.register("collapsible", CollapsibleController)
application.register("scroll-reveal", ScrollRevealController)
